import table from './table'

const applications =
{
    ...table,
    helmet :
    {
        title : 'Applications' ,
        metas : []
    },
    empty  : 'Aucune application trouvée',
    search : 'Rechercher une application ...' ,
    title  : 'Applications'
};

export default applications ;
